import * as API from '../api';

export const get = (areas) => {
    return API.getCourses(areas);
};



// WEBPACK FOOTER //
// ./src/controllers/courses.js